import "./home.css";

import React from "react";
import { Link } from "react-router-dom";

import { HOME, ROUTES, TICKER } from "../../data/content";
import Divider from "../general/Divider";
import PageMeta from "../general/PageMeta";
import SocialTiles from "../general/SocialTiles";

//Product bags peeking in from the sides of the "View our products" section
const SIDE_BAGS = [
  { src: "/images/products/snax-stix-jalapeno-cheese.webp", className: "is-left-back" },
  { src: "/images/products/popcorn-fruit-chutney.webp", className: "is-left-front" },
  { src: "/images/products/pyramid-crackers-jalapeno-cheese.webp", className: "is-right-back" },
  { src: "/images/products/noodles-fettuccine.webp", className: "is-right-front" },
];

const TickerItems = ({ isCopy = false }) => (
  <ul
    className={"ticker-list"}
    aria-hidden={isCopy ? "true" : undefined}
  >
    {TICKER.map((item) => (
      <li key={item.label}>
        {item.range ? (
          <Link
            to={`${ROUTES.PRODUCTS}#${item.range}`}
            tabIndex={isCopy ? -1 : undefined}
          >
            {item.label}
          </Link>
        ) : item.label}
        <span
          className={"ticker-star"}
          aria-hidden={"true"}
        >
          ✦
        </span>
      </li>
    ))}
  </ul>
);

const Home = () => {
  const productsRef = React.useRef(null);
  const [areBagsVisible, setAreBagsVisible] = React.useState(false);

  //Bounce the bags in when the section scrolls into view (as on Wix), rather than on page load where nobody sees it
  React.useEffect(() => {
    if (!("IntersectionObserver" in window)) {
      setAreBagsVisible(true);
      return undefined;
    }
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        setAreBagsVisible(true);
        observer.disconnect();
      }
    }, { threshold: 0.25 });
    observer.observe(productsRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <React.Fragment>
      <PageMeta
        title={HOME.TITLE}
        isFullTitle
      />

      <section className={"home-hero"}>
        <div className={"home-hero-text"}>
          <h1 className={"home-hero-title"}>
            <span className={"is-green"}>{HOME.HERO_GREEN}</span>
            <br />
            {HOME.HERO_BROWN}
          </h1>
        </div>
        <div className={"home-hero-photo"}>
          <img
            src={"/images/home/hero.webp"}
            alt={"Salgado's Snax Stix, Pyramid Crackers and Air-Popped Popcorn with bowls of popcorn and snacks"}
            width={842}
            height={1264}
          />
        </div>
      </section>

      <div
        className={"stripe-band"}
        style={{ "--band": "var(--green)" }}
      />
      {/* Scrolling list of the product ranges - two copies so it loops seamlessly */}
      <section
        className={"ticker"}
        aria-label={"Our product ranges"}
      >
        <div className={"ticker-track"}>
          <TickerItems />
          <TickerItems isCopy />
        </div>
      </section>
      <div
        className={"stripe-band"}
        style={{ "--band": "var(--green)" }}
      />

      <section className={"home-intro"}>
        <div className={"home-intro-inner container"}>
          <div className={"home-intro-text"}>
            <h2 className={"section-title"}>
              Family. Quality. <span className={"is-yellow"}>Care.</span>
            </h2>
            <p>{HOME.INTRO}</p>
            <Link
              to={ROUTES.ABOUT}
              className={"btn"}
            >
              READ MORE
            </Link>
          </div>
          <img
            src={"/images/home/chef.webp"}
            alt={""}
            className={"home-intro-chef"}
            width={301}
            height={943}
            loading={"lazy"}
          />
        </div>
      </section>

      <section
        ref={productsRef}
        className={`home-products ${areBagsVisible ? "is-visible" : ""}`}
        style={{ "--divider": "var(--green)" }}
      >
        <Divider shape={"zigzag-down"} />
        <div className={"home-products-inner"}>
          <div className={"home-products-text"}>
            <h2 className={"section-title"}>
              <span className={"is-terracotta"}>Family. Quality. </span>
              <span className={"is-green"}>Care.</span>
            </h2>
            <Link
              to={ROUTES.PRODUCTS}
              className={"btn"}
            >
              VIEW OUR PRODUCTS
            </Link>
          </div>
          {SIDE_BAGS.map((bag) => (
            <img
              key={bag.src}
              src={bag.src}
              alt={""}
              className={`home-products-bag ${bag.className}`}
              width={1000}
              height={1000}
              loading={"lazy"}
            />
          ))}
        </div>
        <div style={{ "--divider": "var(--coral)" }}>
          <Divider shape={"wave"} />
        </div>
      </section>

      <section className={"home-discover"}>
        <div className={"container"}>
          <h2 className={"section-title"}>
            DISCOVER <span className={"is-cream"}>SALGADOS.</span>
          </h2>
          <div className={"home-discover-photos"}>
            {HOME.DISCOVER_PHOTOS.map((photo) => (
              <img
                key={photo.src}
                src={photo.src}
                alt={photo.alt}
                width={960}
                height={1280}
                loading={"lazy"}
              />
            ))}
          </div>
          <SocialTiles className={"home-social"} />
        </div>
      </section>
      <div
        className={"stripe-band"}
        style={{ "--band": "var(--coral)" }}
      />
    </React.Fragment>
  );
};

export default Home;
